<template>
  <div class="recharge_left capital_first">
    <ul class="sell_ul1">
      <li v-for="(item,index) in list" :key="index" @click="goDetails(item.cid)">
        <p class="sell_p8"></p>
        <div>
          <div class="sell_title">
            <p>{{item.name}}({{item.order}})</p>
            <span></span>
            <small>{{item.time}}</small>
          </div>
          <p class="sell_p9" style="margin-top: 38px;">
            <span>
              申请额度：
              <small>{{item.total}}</small>
            </span>
            <span>
              盈亏：
              <small style="color: #ed0003;">{{item.profit}}({{item.proportion}}%)</small>
            </span>
            <span>
              <small></small>
            </span>
          </p>
          <p class="sell_p9" style="margin-bottom: 45px;">
            <span>
              出发警戒：
              <small style="color: #f06f11;">{{item.warning}}</small>
            </span>
            <span>
              触发止损：
              <small style="color: #ed0003;">{{item.close}}</small>
            </span>
            <span>
              冻结资金：
              <small style="color: #304479;">{{item.bond}}</small>
            </span>
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  name: "Strategyhistory",
  mounted: function() {
    this.getHistoryData();
  },
  data() {
    return {
      list: []
    };
  },
  methods: {
    getHistoryData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "history_operate",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.list = res.data.data;
            if (that.list.length == 0) {
              that.$message({
                message: "暂无记录",
                type: "warning"
              });
            }
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //去详情
    goDetails(cid) {
      window.sessionStorage.setItem("cid",cid);
      this.$router.push({
        path: "/myaccount/strategyhistorydetails"
      });
    }
  }
};
</script>
<style scoped>
</style>





// WEBPACK FOOTER //
// src/components/strategyhistory.vue